import { render, staticRenderFns } from "./ProFeature.vue?vue&type=template&id=179f30f0&scoped=true&"
import script from "./ProFeature.vue?vue&type=script&lang=js&"
export * from "./ProFeature.vue?vue&type=script&lang=js&"
import style0 from "./ProFeature.vue?vue&type=style&index=0&id=179f30f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f30f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179f30f0')) {
      api.createRecord('179f30f0', component.options)
    } else {
      api.reload('179f30f0', component.options)
    }
    module.hot.accept("./ProFeature.vue?vue&type=template&id=179f30f0&scoped=true&", function () {
      api.rerender('179f30f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/dialog/ProFeature.vue"
export default component.exports